import React from 'react';
import { TestimonialCard } from './TestimonialCard';
interface CaseStudy {
  thumbnail: string;
  title: string;
  url: string;
}
export function CaseStudiesSection() {
  const caseStudies: CaseStudy[] = [{
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oKL2RUFhp6qkvbGFwdaDfu/pasted-image.png',
    title: 'From Chronic Pain to Pain Free - Defeating Osteoarthritis',
    url: 'https://youtu.be/226rmSgq68A?si=FvO8wygPjwdfeT8U'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gCHd6t3G7ECjTaZPKrk6a6/pasted-image.png',
    title: 'Complete Upgrade in Business & Life - Total Performance Enhancement',
    url: 'https://youtu.be/VxilMGM7uE8?si=WPp7FEr-gy8F1snb'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oJBi22my5QWSprp2dLrH7P/pasted-image.png',
    title: 'High Radial Nerve Palsy Reversed - From Wrist Drop to Full Recovery',
    url: 'https://youtu.be/DG-Tf01uqfk?si=4u2a-_FsTqzvzGa8'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gWrdoTVTtD8tnzKrhceBmG/pasted-image.png',
    title: 'How He Escaped Dialysis & Reversed Kidney Disease',
    url: 'https://youtu.be/yrF73YFikJI?si=r77xKstcDTM2PBdo'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sUYNQpBzsywUhjzha6Ud1E/pasted-image.png',
    title: 'Beating "Incurable" Autoimmune Disease - Reversing Rheumatoid Arthritis',
    url: 'https://youtu.be/VLAbfsKtAvo?si=0UdYOxyYJxdnf-SV'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2RDUn16cxVxDMPjfP6bCVd/pasted-image.png',
    title: 'Reversing Heart Failure - No Longer Needs Heart Transplant',
    url: 'https://youtu.be/bmLQYGeC960?si=cGt3AQfMjNz3nBNi'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3tJoDykHovRmH2SXskyd54/pasted-image.png',
    title: 'Defying Age: From Burnout to 15-Year Biological Age Reversal',
    url: 'https://youtu.be/YwEywZxMSgo?si=sxvzMNW78swQxJM8'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tA6F2wb81UfvKyHq7dYXrw/pasted-image.png',
    title: 'From Cognitive Decline to Mental Superhuman',
    url: 'https://youtu.be/bdFY2s3nbtM?si=ylMcP485F9gONF5x'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qZ4EpkZoX599qCEfq3gNVv/pasted-image.png',
    title: "How We're Reversing Alzheimer's Disease - The Breakthrough Approach",
    url: 'https://youtu.be/TEDmmZfPIa0?si=oPFcNi7vt43c2VuT'
  }];
  return <div className="grain-section w-full px-6 py-32 md:py-40 bg-page-bg" data-id="element-18">
      <div className="max-w-7xl mx-auto space-y-24" data-id="element-19">
        <div className="text-center space-y-8" data-id="element-20">
          <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-21">
            Real Transformations From Real People
          </h2>
          <div className="w-24 h-1.5 bg-teal-100 mx-auto rounded-full" data-id="element-22"></div>
          <p className="text-xl text-ink-light font-light" data-id="element-23">
            Don't just take my word for it. Watch these case studies and see for
            yourself. These aren't small wins. These are life-changing
            transformations. The kind conventional medicine calls "impossible."
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-24">
          {caseStudies.map((study, index) => <a key={index} href={study.url} target="_blank" rel="noopener noreferrer" className="flex flex-col gap-6 bg-white border border-black/5 p-6 rounded-3xl transition-all duration-300 hover:shadow-lg hover:border-teal-200 group h-full" data-id="element-25">
              <div className="flex-shrink-0 overflow-hidden rounded-2xl aspect-video" data-id="element-26">
                <img src={study.thumbnail} alt={study.title} className="w-full h-full object-cover transition-all duration-500 transform group-hover:scale-105" data-id="element-27" />
              </div>
              <div className="flex items-start flex-1" data-id="element-28">
                <h3 className="text-xl font-bold text-ink group-hover:text-teal-600 transition-colors duration-300 leading-tight" data-id="element-29">
                  {study.title}
                </h3>
              </div>
            </a>)}
        </div>

        <div className="max-w-4xl mx-auto space-y-8 pt-16" data-id="element-30">
          <TestimonialCard text="Update on grandparents with peptides: He just called me to update me he feels 20 years younger and she is doing yard work AND just did a 100 piece jigsaw puzzle (she's loved puzzles her whole life). 6 months ago she couldn't do a five piece jigsaw puzzle. I don't care what anyone says, peptides f**king work." highlight={true} profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/oEpan9Q2S1ziM4cjxAeF15/image.png" name="Kademlia, Transformation Services Client & Peptide Mastery Buyer" data-id="element-31" />
          <TestimonialCard text="Increased muscle tone & strength, improved skin tone and elasticity. As well as more sharp and dialled in you can say I feel revived/revamped into my younger self it feels like, everything from my sense of smell, taste, sight, hearing and unique feeling of mind and body connection/connectivity profoundly escalated. Feels like my whole being has been enhanced." name="Rick G., Peptide Mastery buyer" data-id="element-32" />
        </div>

        <div className="text-center pt-16" data-id="element-33">
          <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="px-12 py-6 bg-gradient-to-r from-[#1d1d1f] to-[#2d2d2f] hover:from-black hover:to-[#1a1a1c] text-white text-xl font-bold rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-34">
            Book Your Meeting
          </a>
        </div>
      </div>
    </div>;
}